import * as e from "react";
import { forwardRef as r } from "react";
const o = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M10 3.5H14.4C14.8055 3.5 15.1333 3.80731 15.1333 4.1875V19.3125C15.1333 19.6927 14.8055 20 14.4 20H10C9.59447 20 9.26667 19.6927 9.26667 19.3125V4.1875C9.26667 3.80731 9.59447 3.5 10 3.5ZM4.13333 7.625H7.8C8.20553 7.625 8.53333 7.93231 8.53333 8.3125V19.3125C8.53333 19.6927 8.20553 20 7.8 20H4.13333C3.7278 20 3.4 19.6927 3.4 19.3125V8.3125C3.4 7.93231 3.7278 7.625 4.13333 7.625ZM16.6 13.8125H20.2667C20.6722 13.8125 21 14.1198 21 14.5V19.3125C21 19.6927 20.6722 20 20.2667 20H16.6C16.1945 20 15.8667 19.6927 15.8667 19.3125V14.5C15.8667 14.1198 16.1945 13.8125 16.6 13.8125Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement(
      "rect",
      {
        fill: "currentColor",
        height: 16.5,
        transform: "translate(3.4 3.5)",
        width: 17.6
      }
    )))
  );
});
export {
  o as LiveData
};
